import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/assets/styles/App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Importar configuración de i18n



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
